export default __webpack_public_path__ + "static/media/pfp-yellow.e25032be.svg";